import { render } from "./BaseFinder.vue?vue&type=template&id=b455f680"
const script = {}

import "./BaseFinder.vue?vue&type=style&index=0&id=b455f680&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__